import { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { useIntl } from 'gatsby-plugin-react-intl';

import Container from '../../Core/Container';
import Pagination from '../../Core/Pagination';
import ContentItem from '../ContentItem';

import { Wrapper } from './styles';

const ContentCenter = () => {
  const [currentPage, setCurrentPage] = useState(1);
  // Get current articles to show
  const {
    allContentfulArticles: { edges: article },
  } = useStaticQuery(query);
  const intl = useIntl();
  const currentLang = intl.locale === 'en' ? 'en-CA' : 'fr-CA';
  const langFilteredArticles = article.filter(
    arts => arts.node.node_locale === currentLang,
  );
  const sortedFilteredArticles = langFilteredArticles.sort((a, b) => {
    if (a.node.publishDate === b.node.publishDate) {
      return 0;
    }
    // nulls sort after anything else
    else if (a.node.publishDate === null) {
      return 1;
    } else if (b.node.publishDate === null) {
      return -1;
    }
    return 0;
  });
  const articlesPerPage = 8;
  const totalArticle = sortedFilteredArticles.length;
  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = sortedFilteredArticles.slice(
    indexOfFirstArticle,
    indexOfLastArticle,
  );

  const paginate = pageNumber => {
    setCurrentPage(pageNumber);
  };

  return (
    <Container as="section" className="media-centre">
      <Wrapper>
        <ContentItem currentArticles={currentArticles} />
        {totalArticle > articlesPerPage && (
          <Pagination
            paginate={paginate}
            totalArticle={totalArticle}
            currentPage={currentPage}
            articlesPerPage={articlesPerPage}
          />
        )}
      </Wrapper>
    </Container>
  );
};

const query = graphql`
  query MediaCentreArticles {
    allContentfulArticles(
      filter: { articleType: { eq: "media" } }
      sort: { publishDate: DESC }
    ) {
      edges {
        node {
          id
          pageSlug
          node_locale
          publishDate
          headline {
            raw
          }
        }
      }
    }
  }
`;

export default ContentCenter;
